var map = {
	"./logo_132.png": 1132,
	"./logo_24.png": 1133,
	"./logo_311.png": 1134,
	"./logo_42.png": 1135,
	"./logo_46.png": 1136,
	"./logo_47.png": 1137,
	"./logo_48.png": 1138,
	"./logo_51.png": 1139,
	"./logo_53.png": 1140,
	"./logo_54.png": 1141,
	"./logo_55.png": 1142,
	"./logo_57.png": 1143,
	"./logo_85.png": 1144,
	"./logo_87.png": 1145,
	"./logo_9436.png": 1146,
	"./logo_9444.png": 1147
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1047;


//////////////////
// WEBPACK FOOTER
// ./assets/leagues ^\.\/logo_.*\.png$
// module id = 1047
// module chunks = 0 1